const createFormDataArrOfAttachments = (attachments) => {
  const formData = new FormData();
  attachments.forEach((file) => {
    formData.append('file', file, file.name);
  });
  return formData;
};

export default createFormDataArrOfAttachments;
